import React, {useState, useEffect} from "react";
import { GetCategoriesBlogData} from "../../../lib/data";
import AddCategoiresUi from "../../../ui/categoriesUi/AddCategoriesUi";
import AddBlogsUi from "../../../ui/blogsUi/addBlogsUi";
import i18n from "../../../lib/i18n";

export default function AddBlogs () {

    const [categoriesBlogData, setCategoriesBlogData] = useState([]);
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const categoriesBlogsData = await GetCategoriesBlogData();
        setCategoriesBlogData([]);
        categoriesBlogsData.data.map((e) => setCategoriesBlogData((prev) => [...prev, e]));
    };

    const search = async (param) => {
        const params = [ {"name": param} ];
        if(param){
            const categoriesBlogsDataFilter = await GetCategoriesBlogData(1,params);
            setCategoriesBlogData([]);
            categoriesBlogsDataFilter.data.map((e) => setCategoriesBlogData((prev) => [...prev, e]));
        }
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("add_page_title.blog")}</h1>
                <AddBlogsUi search={search} categoriesBlogData={categoriesBlogData} />
            </div>
        </div>
    );
};